var CONTROL_ROWS = [{
  label: 'D-Up',
  key: 1,
  joy: 1,
  mapKey: 'Mapping_Up',
  mapJoy: 'Joy_Mapping_Up'
}, {
  label: 'D-Down',
  key: 2,
  joy: 2,
  mapKey: 'Mapping_Down',
  mapJoy: 'Joy_Mapping_Down'
}, {
  label: 'D-Left',
  key: 3,
  joy: 3,
  mapKey: 'Mapping_Left',
  mapJoy: 'Joy_Mapping_Left'
}, {
  label: 'D-Right',
  key: 4,
  joy: 4,
  mapKey: 'Mapping_Right',
  mapJoy: 'Joy_Mapping_Right'
}, {
  label: 'A',
  key: 5,
  joy: 5,
  mapKey: 'Mapping_Action_A',
  mapJoy: 'Joy_Mapping_Action_A'
}, {
  label: 'B',
  key: 6,
  joy: 6,
  mapKey: 'Mapping_Action_B',
  mapJoy: 'Joy_Mapping_Action_B'
}, {
  label: 'Start',
  key: 8,
  joy: 8,
  mapKey: 'Mapping_Action_Start',
  mapJoy: 'Joy_Mapping_Action_Start'
}, {
  label: 'Z',
  key: 10,
  joy: 10,
  mapKey: 'Mapping_Action_Z',
  mapJoy: 'Joy_Mapping_Action_Z'
}, {
  label: 'L',
  key: 11,
  joy: 11,
  mapKey: 'Mapping_Action_L',
  mapJoy: 'Joy_Mapping_Action_L'
}, {
  label: 'R',
  key: 12,
  joy: 12,
  mapKey: 'Mapping_Action_R',
  mapJoy: 'Joy_Mapping_Action_R'
}, {
  label: 'Menu',
  key: 9,
  joy: 9,
  mapKey: 'Mapping_Menu',
  mapJoy: 'Joy_Mapping_Menu'
}, {
  label: 'C-Up',
  key: 13,
  joy: 0,
  mapKey: 'Mapping_Action_CUP',
  mapJoy: ''
}, {
  label: 'C-Down',
  key: 14,
  joy: 0,
  mapKey: 'Mapping_Action_CDOWN',
  mapJoy: ''
}, {
  label: 'C-Left',
  key: 15,
  joy: 0,
  mapKey: 'Mapping_Action_CLEFT',
  mapJoy: ''
}, {
  label: 'C-Right',
  key: 16,
  joy: 0,
  mapKey: 'Mapping_Action_CRIGHT',
  mapJoy: ''
}, {
  label: 'Analog Up',
  key: 17,
  joy: 0,
  mapKey: 'Mapping_Action_Analog_Up',
  mapJoy: ''
}, {
  label: 'Analog Down',
  key: 18,
  joy: 0,
  mapKey: 'Mapping_Action_Analog_Down',
  mapJoy: ''
}, {
  label: 'Analog Left',
  key: 19,
  joy: 0,
  mapKey: 'Mapping_Action_Analog_Left',
  mapJoy: ''
}, {
  label: 'Analog Right',
  key: 20,
  joy: 0,
  mapKey: 'Mapping_Action_Analog_Right',
  mapJoy: ''
}];
module.exports = function (app, mod) {
  var mappings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var rows = CONTROL_ROWS.map(function (row) {
    var keyVal = mappings[row.mapKey] || '';
    var joyVal = row.mapJoy ? mappings[row.mapJoy] || '' : '';
    var joyBtn = row.joy ? "<button type=\"button\" class=\"saito-button-secondary\" data-action=\"remap-joy\" data-id=\"".concat(row.joy, "\">Joypad</button>") : '';
    return "\n      <div class=\"row\">\n        <div class=\"label\">".concat(row.label, "</div>\n        <div class=\"binding\" data-map=\"").concat(row.mapKey, "\">").concat(keyVal, "</div>\n        <div class=\"binding\" data-map=\"").concat(row.mapJoy || '', "\">").concat(joyVal, "</div>\n        <div class=\"actions\">\n          <button type=\"button\" class=\"saito-button-secondary\" data-action=\"remap-key\" data-id=\"").concat(row.key, "\">Key</button>\n          ").concat(joyBtn, "\n        </div>\n      </div>\n    ");
  }).join('');
  return "\n    <div class=\"nwasm-controls saito-overlay-form\">\n      <div class=\"saito-overlay-form-header\">\n        <h2 class=\"saito-overlay-form-header-title\">Controller Mapping</h2>\n      </div>\n      <div class=\"body\">\n        <div class=\"wait\" hidden>Press a key or joypad button\u2026</div>\n        <div class=\"list\">\n          <div class=\"row head\">\n            <div class=\"label\">Button</div>\n            <div class=\"binding\">Keyboard</div>\n            <div class=\"binding\">Joypad</div>\n            <div class=\"actions\">Remap</div>\n          </div>\n          ".concat(rows, "\n        </div>\n      </div>\n      <div class=\"saito-button-row\">\n        <button type=\"button\" class=\"saito-button-secondary\" data-action=\"defaults\">Restore Defaults</button>\n        <button type=\"button\" class=\"saito-button-primary\" data-action=\"save\">Save Changes</button>\n      </div>\n    </div>\n  ");
};
module.exports.CONTROL_ROWS = CONTROL_ROWS;